import React from 'react';

import {AutomationOutputFileConfig} from 'lab-automation/automation-files/LabAutomationConstants';
import {ClientAutomationOutputFileConfigSpec} from 'lab-automation/settings/RunSchemaSpecConstants';
import AsyncButton, {AsyncButtonLoadingBehavior} from 'ui-library/buttons/AsyncButton';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {InstrumentData, InstrumentQueryStatus} from './InstrumentDataConstants';
import {createCopyObjectInstrumentQuery, pollInstrumentQueryStatus, RunReference} from './InstrumentDataDAO';

export interface RefetchFileButtonProps {
  instrumentData: InstrumentData;
  isConnectionAvailable: boolean;
  loginUsername: string | null;
  // The run whose fields the refetch sends to the connection, if any.
  run?: RunReference;
  automationOutputFileConfig?: AutomationOutputFileConfig | ClientAutomationOutputFileConfigSpec | null;
  onRefetchComplete: () => Promise<void>;
}

async function submitCopyObject(
  instrumentData: InstrumentData,
  loginUsername: string | null,
  run: RunReference | undefined
): Promise<InstrumentQueryStatus> {
  const params: {[key: string]: string | boolean} = {};
  if (loginUsername) {
    params.username = loginUsername;
  }
  const instrumentQueryId = (await createCopyObjectInstrumentQuery(instrumentData, params, run))
    .instrumentQueryId;

  const query = await pollInstrumentQueryStatus(instrumentQueryId);
  return query.status;
}

export default function RefetchFileButton(props: RefetchFileButtonProps): JSX.Element {
  return (
    <Tooltip
      isDisabled={props.isConnectionAvailable}
      text={!props.isConnectionAvailable ? 'Connection unavailable.' : null}
    >
      <AsyncButton
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        loadingBehavior={AsyncButtonLoadingBehavior.SPINNER}
        size={ButtonSize.SMALL}
        onClick={async () => {
          await submitCopyObject(props.instrumentData, props.loginUsername, props.run);
          await props.onRefetchComplete();
        }}
        text={<BenchlingIcon icon="refresh" />}
        disabled={!props.isConnectionAvailable}
      />
    </Tooltip>
  );
}
